import { render, staticRenderFns } from "./VerticalEdit.vue?vue&type=template&id=015d0558&scoped=true"
import script from "./VerticalEdit.vue?vue&type=script&lang=js"
export * from "./VerticalEdit.vue?vue&type=script&lang=js"
import style0 from "./VerticalEdit.vue?vue&type=style&index=0&id=015d0558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d0558",
  null
  
)

export default component.exports